import { render, staticRenderFns } from "./EditPropertyMenu.vue?vue&type=template&id=3c9a1303&scoped=true&"
import script from "./EditPropertyMenu.vue?vue&type=script&lang=js&"
export * from "./EditPropertyMenu.vue?vue&type=script&lang=js&"
import style0 from "./EditPropertyMenu.vue?vue&type=style&index=0&id=3c9a1303&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9a1303",
  null
  
)

export default component.exports